import React from 'react'
import classes from './button.module.css'
import {Button} from 'antd'
const ModBtn = ({children, onClick, extraClass,disabled, isLoading}) =>{

    return(
        <Button 
        disabled={disabled}
        onClick={onClick} className={[classes.button, extraClass].join(' ')}
        size="large"
        loading={isLoading}
        >
            {children}

        </Button>
    )

}

export default ModBtn;